import { useEffect, useState } from 'react';

const useTimer = (shouldRun: boolean, UPDATE_INTERVAL = 1000): Date => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    if (!shouldRun) {
      return;
    }

    const interval = setInterval(() => setNow(new Date()), UPDATE_INTERVAL);
    // eslint-disable-next-line consistent-return
    return () => clearInterval(interval);
  }, [shouldRun, UPDATE_INTERVAL]);

  return now;
};

export default useTimer;
